import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../environments/environment';

const HOST = environment.serverUrl;
const CHARGEPOINTS_API_URL = HOST + '/okecharge/plugs';

@Injectable({ providedIn: 'root' })
export class ChargepointsOkechargeApiService {

  constructor(private http: HttpClient) { }

  public requestStatus(chargepointId: string): Observable<void> {
    return this.http.get<void>(`${CHARGEPOINTS_API_URL}/${chargepointId}/ask-status`, {});
  }
}
